var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRememberMeCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16px/Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5303 3.53033L5.5 12.5607L1.46967 8.53033L2.53033 7.46967L5.5 10.4393L13.4697 2.46967L14.5303 3.53033Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRememberMeCheck);
export default __webpack_public_path__ + "static/media/remember-me-check.8959abb6e24e894bd956be7e2ce97702.svg";
export { ForwardRef as ReactComponent };